import { Stack } from "@mui/material";
import { groupBy } from "ramda";
import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import { AttributeValue } from "../../Attribute/AttributeValue";
import { StaffFragment } from "@sinch/components/application/StaffDetailPanel/queries.types";
import { FormSecondTitle } from "@sinch/components/typography/FormSecondTitle/FormSecondTitle";

interface PersonalAttributesProps {
  staff: StaffFragment;
}

export const PersonalAttributes: FC<PersonalAttributesProps> = ({ staff }) => {
  const { t } = useTranslation();
  const aggregatedAttributes = groupBy(
    (item) => item.attribute.block?.name ?? t("miscellaneous"),
    staff?.personalAttributes ?? []
  );

  return Object.entries(aggregatedAttributes).map(([category, items]) => (
    <Stack key={category}>
      <FormSecondTitle title={category} />
      <Stack direction="column">
        {items.map((item: Record<string, any>) => (
          <AttributeValue
            key={item.id}
            files={item.files}
            label={item.attribute.name}
            options={item.attribute.options}
            type={item.attribute.dataType}
            value={item.value}
          />
        ))}
      </Stack>
    </Stack>
  ));
};
